module.exports = __webpack_public_path__ + "media/images/products/category/sm/10-0d5a8fd9ab8681278368d12c7e420547.jpg";